import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSnapshots, setLoading } from "../store/historySlice";
import { fetchHistory } from "../sync/syncService";
import { colors, space } from "../design/tokens";
import { Screen, Content, Card, Text, Row } from "../components/layout";

export default function OverviewPage() {
  const dispatch = useDispatch();
  const { snapshots, loading } = useSelector(state => state.history);

  useEffect(() => {
    dispatch(setLoading(true));
    fetchHistory().then(data => {
      dispatch(setSnapshots(data));
      dispatch(setLoading(false));
    });
  }, [dispatch]);

//   const days = snapshots
//     .map(({ date, data }) => ({
//       date,
//       calories: (data.entries ?? []).reduce((sum, e) => sum + (e.calories ?? 0), 0),
//     }))
//     .sort((a, b) => b.date.localeCompare(a.date));
const days = [...(snapshots ?? [])].sort((a, b) => b.date.localeCompare(a.date));

  return (
    <Screen>
      <Content>
        <Card style={{ padding: space.sm, gap: space.lg }}>
          <Text variant="h1">Overview</Text>

          {loading && <Text style={{ color: colors.textMuted }}>Loading…</Text>}

          {!loading && days.length === 0 && (
            <Text style={{ color: colors.textMuted }}>No history yet.</Text>
          )}

          {days.map(({ date, calories }) => (
            <>
                <Row key={date} style={{ justifyContent: "space-between", alignItems: "center" }}>
                <Text>{date}</Text>
                <Text style={{ color: colors.textMuted }}>{calories} kcal</Text>
                </Row>
                <hr style={{margin:0}}/>
            </>
          ))}
        </Card>
      </Content>
    </Screen>
  );
}